import GoBackButton from '@/common/components/GoBackButton';
import useCompany from '@/common/hooks/queries/useCompany'
import { useCompanyBranch } from '@/features/privateCompanies/hooks/useCompanyBranch';
import { useCompanyGovernmentAllocationEntry } from '@/features/privateCompanies/hooks/useCompanyGovernmentAllocationEntry'
import { governmentAllocationFormStateOptions } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Update/constants/governmentAllocationFormStateOptions.constant'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'
import UpdateGovernmentAllocationLoadingState from './components/UpdateGovernmentAllocationLoadingState';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';

const Update = () => {
  const { id, companyId } = useParams()

  const { data: company, isPending: companyIsPending } = useCompany({ id: companyId || '' })

  const {
    data: companyGovernmentAllocation,
    isPending: companyGovernmentAllocationIsPending,
    error: companyGovernmentAllocationError = {} as any,
    refetch: refetchCompanyGovernmentAllocation,
  } = useCompanyGovernmentAllocationEntry(id || '')

  const { data: companyBranch, isPending: companyBranchIsPending } = useCompanyBranch(
    companyGovernmentAllocation?.government_allocation?.branch_id || '',
    !!companyGovernmentAllocation?.government_allocation?.branch_id)

  if (
    companyGovernmentAllocationIsPending ||
    (companyBranchIsPending && companyGovernmentAllocation?.government_allocation?.branch_id) ||
    companyIsPending
  ) {
    return <UpdateGovernmentAllocationLoadingState />
  }

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={companyGovernmentAllocationError?.status}
      refetchFunction={refetchCompanyGovernmentAllocation}
      notFoundFallback={`/companies/${companyId}/government-allocation`}
      notFoundButtonText={
        company?.current_contract?.payment_modality === 'pre_paid'
          ? 'Ir para Empenhos'
          : 'Ir para Cotas'
      }
    >
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-4 items-center">
            <GoBackButton fallback={`/companies/${companyId}/government-allocation`} searchLastRouteIgnoringFilters />

            <div className="flex items-center gap-1">
              <p className="text-white-400">
                {company?.general_information?.fantasy_name + ` (${companyBranch?.display_name})`}
              </p>

              <ChevronsRightIcon className="text-white-400" />

              <p className="text-white-800">{companyGovernmentAllocation?.office_number}</p>
            </div>
          </div>
        </div>

        {!companyGovernmentAllocationIsPending && companyGovernmentAllocation && id && (
          <>
            {governmentAllocationFormStateOptions
              .filter(({ value }) => value === companyGovernmentAllocation.status)
              .map(({ comp: Comp }) => {
                return (
                  <Comp
                    key={companyGovernmentAllocation.id}
                    companyGovernmentAllocation={companyGovernmentAllocation}
                  />
                )
              })}
          </>
        )}
      </div>
    </ErrorMessageWrapper>
  )
}

export default Update
